import { SettingOutlined } from '@ant-design/icons';

const parametrizacoes = {
  id: 'group-parametrizacoes',
  title: 'Configurações',
  type: 'group',
  children: [
    {
      id: 'parametrizacoes',
      title: 'Parametrizações',
      type: 'item',
      url: '/parametrizacoes',
      icon: SettingOutlined,
      breadcrumbs: false,
    },
  ],
};

export default parametrizacoes;
